import React from 'react';
import { useParams, useLocation } from 'react-router';
import * as QueryString from 'query-string';
import { EntrepreneurContextProvider, useUser } from '../contexts';
import { ProfileAccessLevel, Role } from '../types/types';
import EntrepreneurPage from './entrepreneur/EntrepreneurPage';

interface EntrepreneurProfileRouterParams {
  profileId: string
}

const EntrepreneurPageRouter = () => {
  const pathParams = useParams<EntrepreneurProfileRouterParams>();
  const profileId = parseInt(pathParams.profileId);
  const { userInfo } = useUser();

  // 1. unauthed person
  // 2. authened person (ent profile owner)
  // 3. authed person (non ent profile owner)
  let pR = ProfileAccessLevel.Anonymous;
  if (userInfo) pR = ProfileAccessLevel.AuthedNonOwner;
  if (userInfo?.profileId === profileId && userInfo.role === Role.Ent) pR = ProfileAccessLevel.AuthedOwner;

  // check if has referral
  const queryParams = QueryString.parse(useLocation().search);
  const referral = queryParams.referral as string || undefined;
  const referralOrigin = queryParams.referralOrigin as string || undefined;

  return (
    <EntrepreneurContextProvider
      entProfileId={profileId}
      accessLevel={pR}
      isConnectorUser={(userInfo && userInfo.role === Role.Connector) || false}
      referral={referral}
      referralOrigin={referralOrigin}
    >
      <EntrepreneurPage />
    </EntrepreneurContextProvider>
  );
};

export default EntrepreneurPageRouter;
